// proef's line icon set: a 24-unit grid, 1.6 stroke, round caps and joins —
// the same optical weight as heroicons' outline set, so the Expo app
// (docs/design-system.md names heroicons) and this PWA read as one family
// while this package stays dependency-free (AGENTS.md checkpoint #3 forbids
// adding a library without approval). Icons are decorative by default; pass
// `label` when an icon stands alone and must be announced.

const ICONS = {
  scan: (
    <>
      <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
      <path d="M7 12h10" />
    </>
  ),
  camera: (
    <>
      <path d="M4 8.5A1.5 1.5 0 0 1 5.5 7H8l1.3-2h5.4L16 7h2.5A1.5 1.5 0 0 1 20 8.5V17a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
      <circle cx="12" cy="12.5" r="3.2" />
    </>
  ),
  torch: <path d="M13 2 5 14h6l-1 8 8-12h-6z" />,
  image: (
    <>
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" />
      <path d="M4 16.5 8.5 12l3.5 3 3-2.5 5 4.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-3.8-3.8" />
    </>
  ),
  pencil: (
    <>
      <path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16z" />
      <path d="M13 7l4 4" />
    </>
  ),
  cellar: (
    <>
      <path d="M4 9.5 12 4l8 5.5V20H4z" />
      <path d="M8 13h8M8 17h8" />
    </>
  ),
  glass: (
    <>
      <path d="M7 3h10l-.7 7.2C16 14.5 14.3 17 12 17s-4-2.5-4.3-6.8L7 3z" />
      <path d="M12 17v4M9 21h6" />
    </>
  ),
  // The tulip glass of the journal hero (Glass.tsx) as a line icon: curved bowl, the wine's surface, a stem.
  tulip: (
    <>
      <path d="M6.8 3h10.4l-.5 6.4c-.3 4.2-2.1 6.8-4.7 6.8s-4.4-2.6-4.7-6.8L6.8 3z" />
      <path d="M7.6 9h8.8" />
      <path d="M12 16v4.6M8.8 21h6.4" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M15.5 8.5l-2.4 4.6-4.6 2.4 2.4-4.6z" />
    </>
  ),
  person: (
    <>
      <circle cx="12" cy="8.5" r="3.4" />
      <path d="M5 20c1.4-4 4.2-6 7-6s5.6 2 7 6" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8v.01" />
    </>
  ),
  map: (
    <>
      <path d="M3 6.5 9 4l6 2.5 6-2.5v13l-6 2.5-6-2.5-6 2.5z" />
      <path d="M9 4v15M15 6.5v15" />
    </>
  ),
  mountain: (
    <>
      <path d="M2.5 19 9 8l4 6.5 2-3L21.5 19z" />
      <path d="M9 8l-1.5 2.5h3z" />
    </>
  ),
  layers: (
    <>
      <path d="M12 4 3 9l9 5 9-5z" />
      <path d="M3 14l9 5 9-5" />
    </>
  ),
  grape: (
    <>
      <path d="M12 7.5V3.5M12 4c2 0 3.5 1 4 3-2.2.2-3.8-.8-4-3z" />
      <circle cx="12" cy="9.8" r="2.2" />
      <circle cx="8.8" cy="13.4" r="2.2" />
      <circle cx="15.2" cy="13.4" r="2.2" />
      <circle cx="12" cy="17" r="2.2" />
    </>
  ),
  leaf: (
    <>
      <path d="M19 4c-9 0-14 5-14 12 0 1 .2 2 .5 3 5-7 9-9 13-15z" />
      <path d="M5 19c3-4 6-7 10-10" />
    </>
  ),
  droplet: <path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z" />,
  thermometer: (
    <>
      <path d="M10 14.5V5a2 2 0 1 1 4 0v9.5a3.5 3.5 0 1 1-4 0z" />
      <path d="M12 9v8" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 10h16M8 3v4M16 3v4" />
    </>
  ),
  qr: (
    <>
      <rect x="4" y="4" width="6" height="6" rx="1" />
      <rect x="14" y="4" width="6" height="6" rx="1" />
      <rect x="4" y="14" width="6" height="6" rx="1" />
      <path d="M7 7h.01M17 7h.01M7 17h.01M14 14h2v2h-2zM18 14h2M14 18h2M18 18h2v2" />
    </>
  ),
  print: (
    <>
      <path d="M7 8V4h10v4" />
      <path d="M7 17H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
      <path d="M7 14h10v6H7z" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M9 7V4h6v3" />
      <path d="M6 7l1 13h10l1-13" />
      <path d="M10 11v6M14 11v6" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  "chevron-left": <path d="M15 5l-7 7 7 7" />,
  "chevron-right": <path d="M9 5l7 7-7 7" />,
  "chevron-down": <path d="M5 9l7 7 7-7" />,
  "arrow-right": <path d="M5 12h14M13 6l6 6-6 6" />,
  "arrow-up-right": <path d="M7 17 17 7M8 7h9v9" />,
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  badge: (
    <>
      <circle cx="12" cy="9" r="5" />
      <path d="M8.5 13.5 7 21l5-2.5 5 2.5-1.5-7.5" />
    </>
  ),
  trophy: (
    <>
      <path d="M8 4h8v5a4 4 0 0 1-8 0z" />
      <path d="M8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4" />
      <path d="M12 13v4M8 21h8M10 17h4v4" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c3 3.3 3 14.7 0 18M12 3c-3 3.3-3 14.7 0 18" />
    </>
  ),
  bluetooth: <path d="M7 7l10 10-5 4V3l5 4L7 17" />,
  download: <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />,
  refresh: <path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" />,
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  "eye-off": (
    <>
      <path d="M3 3l18 18" />
      <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
      <path d="M6.5 6.7C4.2 8.1 2.5 10 2 12c1.5 4 5.5 7 10 7 1.7 0 3.3-.4 4.7-1.1" />
      <path d="M9.9 5.2A10 10 0 0 1 12 5c4.5 0 8.5 3 10 7-.5 1.3-1.3 2.5-2.3 3.5" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8.5" r="3" />
      <path d="M3 20c1-3.5 3.3-5.5 6-5.5s5 2 6 5.5" />
      <path d="M15 4.5a3 3 0 0 1 0 6M17 14.5c2.2.4 3.5 2.3 4 5.5" />
    </>
  ),
  flag: <path d="M5 21V4M5 4h12l-2 4 2 4H5" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  sparkles: (
    <>
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
      <path d="M19 16l.9 2.1L22 19l-2.1.9L19 22l-.9-2.1L16 19l2.1-.9z" />
    </>
  ),
  bottle: (
    <>
      <path d="M10 3h4v4.5c0 1.5 2.5 2.5 2.5 5V20a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7.5c0-2.5 2.5-3.5 2.5-5z" />
      <path d="M9.5 14h5" />
    </>
  ),
  share: <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 15V3M8 7l4-4 4 4" />,
  // Three linked nodes: the tasting pager's "share this tasting" (the canvas's share button).
  "share-nodes": (
    <>
      <circle cx="18" cy="5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="19" r="2.5" />
      <path d="M8.2 10.8l7.6-4.6M8.2 13.2l7.6 4.6" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
    </>
  ),
  frost: <path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9" />,
  rain: (
    <>
      <path d="M7 15a4.5 4.5 0 0 1-.5-9 6 6 0 0 1 11.5 1.5A3.75 3.75 0 0 1 17.5 15z" />
      <path d="M9 18v2M13 17.5v3M17 18v2" />
    </>
  ),
  waves: <path d="M3 12c2-2 4-2 6 0s4 2 6 0 4-2 6 0M3 17c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />,
  river: <path d="M7 3c0 5 10 5 10 9s-10 4-10 9" />,
  alert: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5M12 16v.01" />
    </>
  ),
  warning: <path d="M12 4 2.5 20h19zM12 10v4M12 17v.01" />,
  "cloud-off": (
    <>
      <path d="M3 3l18 18" />
      <path d="M8.5 18H7a4 4 0 0 1-1.1-7.8M10.7 6.3A6 6 0 0 1 18 11.5a3.5 3.5 0 0 1 2 5.9M12 18h5" />
    </>
  ),
  palette: (
    <>
      <path d="M12 3a9 9 0 1 0 0 18 2 2 0 0 0 1.5-3.3 1.5 1.5 0 0 1 1.1-2.7H17a4 4 0 0 0 4-4c0-4.4-4-8-9-8z" />
      <path d="M7.5 11.5h.01M10.5 7.5h.01M15.5 7.5h.01" />
    </>
  ),
  ruler: (
    <>
      <path d="M3 17 17 3l4 4L7 21z" />
      <path d="M8 16l2 2M11 13l2 2M14 10l2 2" />
    </>
  ),
  star: <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.9l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" />,
  tag: (
    <>
      <path d="M3 12V4h8l9 9-8 8z" />
      <path d="M7.5 7.5h.01" />
    </>
  ),
  list: <path d="M4 7h16M4 12h16M4 17h10" />,
  play: <path d="M7 4.5v15l12-7.5z" />,
  enter: <path d="M10 17l5-5-5-5M15 12H3M13 3h6v18h-6" />,
  moon: <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />,
  shield: <path d="M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6z" />,
  book: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M4 19a2 2 0 0 1 2-2h13" />
    </>
  ),
  wind: <path d="M4 9h11a2.5 2.5 0 1 0-2.4-3.2M4 14h14a2.5 2.5 0 1 1-2.4 3.2" />,
  accessibility: (
    <>
      <circle cx="12" cy="4.5" r="1.8" />
      <path d="M4.5 9h15M12 9v5M12 14l-3.5 6.5M12 14l3.5 6.5" />
    </>
  ),
  // The social-tasting ticket's net-new glyphs (#302): a plus badge on the
  // existing person for "add friend", a chain link and a stacked square for
  // the group invite link's "copy", and a megaphone for a broadcast.
  "person-add": (
    <>
      <circle cx="10" cy="8.5" r="3.4" />
      <path d="M3.5 20c1.2-3.6 3.7-5.5 6.5-5.5s5.3 1.9 6.5 5.5" />
      <path d="M18.5 7v6M15.5 10h6" />
    </>
  ),
  link: (
    <>
      <path d="M9.5 14.5 14.5 9.5" />
      <path d="M11 7.5l1.6-1.6a3.6 3.6 0 0 1 5 5L16 12.5" />
      <path d="M13 16.5l-1.6 1.6a3.6 3.6 0 0 1-5-5L8 11.5" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3" />
    </>
  ),
  megaphone: (
    <>
      <path d="M4 10.5v3a1.5 1.5 0 0 0 1.5 1.5H7l8 4V5l-8 4H5.5A1.5 1.5 0 0 0 4 10.5z" />
      <path d="M11 14.5 12.2 19a1.6 1.6 0 0 1-3 .9L8 15.5" />
    </>
  ),
  // Invite channels: an envelope for mail and a speech bubble for chat apps and text messages.
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  chat: (
    <path d="M5 5h14a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 19 17h-8l-4.5 3.5V17H5a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 5 5z" />
  ),
  // The settings drawer: two sliders, plainer than a cog at row size.
  settings: (
    <>
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="15" cy="7" r="2" />
      <circle cx="9" cy="17" r="2" />
    </>
  ),
};

export type IconName = keyof typeof ICONS;

export function isIconName(value: string): value is IconName {
  return Object.hasOwn(ICONS, value);
}

/** Every icon the set knows, for the registry test and a future gallery. */
export const ICON_NAMES: readonly IconName[] = Object.keys(ICONS).filter(isIconName);

export interface IconProps {
  name: IconName;
  /** Rendered box in px; the stroke scales with it, as a line icon should. */
  size?: number;
  className?: string;
  /** Announces the icon; without it the icon is decorative (aria-hidden). */
  label?: string;
  /** A theme colour (`accent`, `textDim`, `error`...); without it the icon takes its parent's text colour. */
  tone?: string | undefined;
  strokeWidth?: number;
}

export function Icon({
  name,
  size = 22,
  className,
  label,
  tone,
  strokeWidth = 1.6,
}: IconProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(tone === undefined ? {} : { style: { color: `var(--${tone})` } })}
      role={label === undefined ? undefined : "img"}
      aria-hidden={label === undefined ? true : undefined}
      aria-label={label}
      focusable="false"
    >
      {ICONS[name]}
    </svg>
  );
}
